/**
 * the formats for different types of data
 */
export const Defines = {
  Format: {
    MomentDate: "YYYY/MM/DD",
    MomentDateTime: "YYYY/MM/DD HH:mm",
    MomentTime: "HH:mm",
    MomentFullTime: "HH:mm:ss",

    PrintDate: "MM/DD/YYYY", //"MM/dd/yyyy",
    PrintDateTime: "MM/dd/yyyy HH:mm",
    FileNameDate: "yyyyMMdd",
    FileNameDateTime: "yyyy_MM_dd_HH-mm",

    ExpirationDate: "MMddyy",

    InputDate: "MM/dd/yyyy",
    InputTime: "h:mm tt",

    Time: "HH:mm",

    MonthDate: "MMMM, yyyy",

    Number0: "n0"
  },
  Messages: {
    //confirmDelete: "Delete",
    //cancelDelete: "Cancel",
    Yes: "Yes",
    No: "No",
  }
};

/**
 * shorthands to get page urls
 */
export const UserRoles = {
  USER: "sat",
  DISPATCHER: "dispatcher",
  CALL_CENTER: "callcenter",
  READONLY_USER: "readonlyuser"
};

export const AppPages = {
  Home: "home",

  Login: "login",
  Logout: "logout",
  Register: "register",
  Forgot: "forgot",
  NotFound: "notfound",
  Planning: "planning",
  ServiceCalls: "servicecalls",
  ServiceCallsDetails: "servicecallsdetails",
  ServiceCallsUnassigned: "servicecallsunassigned",
  // Documents: "documents",
  Fees: "fees",
  SpareParts: "spareparts",
  DPC: "dpc",
  Attachments: "attachments",
  AttachmentDetails: "attachmentdetails",
  InvoiceGeneration: "invoicegeneration",
  History: "history",
  Template: "template",
  TemplateDetail: "templatedetail",
  ServiceContract: "servicecontract",
  ServiceContractDetails: "servicecontractdetails",
  ContractAttachments: "contractattachments",
  ContractAttachmentDetails: "contractattachmentdetails",
  RedirectResource: 'go'
};

export const StoreKeys = {
  UserToken: "USER-TOKEN",
  AppToken: "APP-TOKEN",
  SessionId: "SessionId",
  UserData: "userData",
  LoggedIn: "loggedIn",
  ListStates: "listStates",
  Culture: "culture",
  Role: "role",
  CurrentNetworkRole: "currentNetworkRole",
  NetworkCode: "networkCode",
  NetworkName: "networkName",
  ExpireTime: "exptime",
  EnableServiceContract: "enableServiceContract",
  DataMaintenance: "dataMaintenance",
  OldToken: "oldToken",
  PortalUrl: "portalUrl"
};

/**
 * the url endings for each action of api
 */
export const ApiUrl = {
  Login: "/Account/Login",
  LoginByCode: "/Account/LoginCode",
  Logout: "/Account/Logout",
  Connect: "/Wso/SSOConnect",
  ConnectAs: "/Account/ConnectAs",
  ConnectAsUser: "/Account/ConnectAsUser",
  AccountCheck: "/Account/Check",

  ValueList: "/api/ValueList/GetList",

  ServiceCallList: "/api/ServiceCall/GetListData",
  ServiceCallLoad: "/api/ServiceCall/ResetFormData",
  ServiceCallUpdate: "/api/ServiceCall/UpdateFormData",
  CreateServiceCall: "/api/ServiceCall/CreateServiceCall",
  ServiceCallDelete: "/api/ServiceCall/DeleteFormData",
  
  ServiceCallLoadLatestBySerialNumber: "/api/ServiceCall/LoadLatestBySerialNumber",
  
  ResendAssignationEmail: "/api/ServiceCall/ResendAssignationEmail",
  GetUnassignedServicaCallsCount: "/api/ServiceCall/GetUnassignedServicaCallsCount",
  ServiceCallExport: "/api/ServiceCall/ExportData",
  EquipmentCardList: "/api/ServiceCall/GetEquipmentCards",
  UpdateEquipmentCard: "/api/ServiceCall/UpdateEquipmentCard",

  FeeList: "/api/ServiceCall/GetFeeData",
  FeeLineLoad: "/api/ServiceCall/GetFeeLines",
  FeeUpdate: "/api/ServiceCall/UpdateFee",
  GenerateInvoice: "/api/ServiceCall/GenerateInvoice",
  DownloadInvoice: "/api/ServiceCall/DownloadInvoice",

  SparePartList: "/api/ServiceCall/GetSparePartData",
  SparePartLineLoad: "/api/ServiceCall/GetSparePartLines",
  SparePartUpdate: "/api/ServiceCall/UpdateSparePart",
  GetItemCodesBySerialNumber: "/api/ServiceCall/GetItemCodesBySerialNumber",

  DPCList: "/api/ServiceCall/GetDPCData",
  DPCDetail: "/api/ServiceCall/GetDPCDetail",
  UpdateDPC: "/api/ServiceCall/UpdateDPC",

  ConfirmDocument: "/api/ServiceCall/ConfirmDocument",
  RejectDocument: "/api/ServiceCall/RejectDocument",
  DefectCodeDetail: "/api/ServiceCall/GetDefectCode",
  DefectCodeUpdate: "/api/ServiceCall/UpdateDefectCode",

  SocieteList: "/api/Societe/GetListData",
  GetSatAddress: "/api/Societe/GetSatAddress",
  GetSatName: "/api/Societe/GetSatName",
  GetSatEmail: "/api/Societe/GetSatEmail",
  GetSatDistance: "/api/Societe/GetSatDistance",

  SocieteInvoiceGenerationDataList: "/api/SocieteInvoiceGenerationData/GetListData",

  AttachmentsList: "/api/Attachments/GetListData",
  AttachmentsUpdate: "/api/Attachments/UpdateAttachments",
  AttachmentsDelete: "/api/Attachments/DeleteFormData",
  GenerateWarrantyCertificate: "/api/Attachments/GenerateWarrantyCertificate",
  GenerateAssignmentReport: "/api/Attachments/GenerateAssignmentReport",
  
  HistoryList: "/api/History/GetListData",

  ServiceContractList: "/api/ServiceContract/GetListData",
  ServiceContractLoad: "/api/ServiceContract/ResetFormData",
  ServiceContractUpdate: "/api/ServiceContract/UpdateFormData",
  CreateServiceContract: "/api/ServiceContract/CreateServiceContract",
  ServiceContractDelete: "/api/ServiceContract/DeleteFormData",

  ServiceContractExport: "/api/ServiceContract/ExportData",

  ContractAttachmentsList: "/api/ContractAttachments/GetListData",
  ContractAttachmentsUpdate: "/api/ContractAttachments/UpdateAttachments",
  ContractAttachmentsDelete: "/api/ContractAttachments/DeleteFormData",

  GetCoverageList: "/api/Coverage/GetCoverageList",
  CoverageList: "/api/Coverage/GetListData",

  EquipmentCardListForContract: "/api/ServiceContract/GetEquipmentCards",
  UpdateEquipmentCardForContract: "/api/ServiceContract/UpdateEquipmentCard",

  GetMaintenance: "/api/Common/GetMaintenance"
};

export const priorities = [
  { id: 'L', colorT: 'transparent', color: 'var(--low-color)', text: 'Low', arrow: 'arrow_down' },
  { id: 'M', colorT: 'transparent', color: 'var(--medium-color)', text: 'Medium', arrow: 'arrow_up' },
  { id: 'H', colorT: 'transparent', color: 'var(--high-color)', text: 'High', arrow: 'arrow_up' },
];


export const ContractStatusesId = {
  APPROVED: "A",
  DRAFT: "D",
  TERMINATED: "T",
  ON_HOLD: "F"
};
